module.exports = __webpack_public_path__ + "static/media/cath_mem.1bb9a111.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/cath_mem.jpg
// module id = 712
// module chunks = 0